import React, { useEffect, useState } from "react";
import api from "../../../api";
import Banner from "./include/Banner";

const API_URL = `${process.env.REACT_APP_API_URL}/api/research/econtents`;
const BASE_URL = process.env.REACT_APP_API_URL;

const ResearchEContents = () => {
  const [eData, setEData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(API_URL);
        // Accessing content from the provided JSON structure
        setEData(response.data.econtents.content);
      } catch (err) {
        console.error("Error fetching E-Contents:", err);
        setError("Failed to load E-Contents data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading || error || !eData) return null;

  // Destructuring updated keys from the JSON response
  const { heading, banner_images, mobile_banner_images, videos } = eData;

  return (
    <>
      {/* Passing both desktop and mobile banners to the Banner component */}
      <Banner
        bannerImages={banner_images}
        mobileBannerImages={mobile_banner_images}
        heading={heading}
      />

      <section className="research_econtents_section">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-12">
              <div className="res-content">
                <div className="sec-title text-center">
                  <h2>{heading}</h2>
                </div>

                <div className="row video-gallery">
                  {videos &&
                    videos.map((video, index) => {
                      let videoUrl = "";
                      let thumbnailUrl = "";

                      // --- Handle Video Playback URL ---
                      if (video.type === "upload") {
                        videoUrl = `${BASE_URL}/public/${video.video_path}`;
                      } else {
                        videoUrl = video.link;
                      }

                      // --- Handle Thumbnail URL Logic ---
                      if (video.thumbnail) {
                        // Use custom uploaded thumbnail if it exists
                        thumbnailUrl = `${BASE_URL}/public/${video.thumbnail}`;
                      } else if (video.type === "link" && video.link) {
                        // Fallback to YouTube auto-thumbnail if it's a link and no custom thumb provided
                        const videoId = video.link.includes("v=")
                          ? video.link.split("v=")[1].split("&")[0]
                          : video.link.split("/").pop().split("?")[0];
                        thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                      } else {
                        // Final fallback placeholder
                        thumbnailUrl = "/assets/images/video-placeholder.jpg";
                      }

                      return (
                        <div className="col-md-3 mb-4" key={index}>
                          <a
                            href={videoUrl}
                            className="glightbox3"
                            data-type="video"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div className="video-card">
                              <img
                                src={thumbnailUrl}
                                alt={video.title || "Video Thumbnail"}
                                className="thumbnail"
                                style={{
                                  width: "100%",
                                  height: "200px",
                                  objectFit: "cover",
                                }}
                              />
                              <img
                                src="/assets/images/youtube-logo-video-player.png"
                                alt="Play Icon"
                                className="play-icon"
                              />
                              {video.title && (
                                <div className="video-title-text mt-2 text-center">
                                  <p>{video.title}</p>
                                </div>
                              )}
                            </div>
                          </a>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchEContents;
